// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__hr4R7","errorLogs":"EditorFooter_errorLogs__3NjN6"};